import React from "react";
import Manamuzlogo from "../../../assets/logo1.jpg";
import styles from "../CSS/logo.module.css";

const navLogo = () => (
	<img className={styles.logo} src={Manamuzlogo} alt="Manamuz logo" />
);

export default navLogo;
